export default "__VITE_ASSET__bb07a62d__"